import { Post,Get } from './Common.ts'
import { GetCultureName, GetReplicatedSiteBusinessName, GetCurrentContentId } from '../stores/SettingsStore.ts'
import { useStoreLogger } from '../logger.ts'
export type CultureItem = {
  cultureName: string
  displayName: string
  countryName: string
  countryCode: string
}

export async function ChangeCulture(cultureName: string): Promise<string> {
  const currentCultureName = await GetCultureName();
  const replicatedSiteBusinessName = await GetReplicatedSiteBusinessName();
  const currentContentId = await GetCurrentContentId();
  const logger = useStoreLogger()
  logger.debug('ChangeCulture', cultureName, currentContentId, currentCultureName, replicatedSiteBusinessName);
  return  await Post("/umbraco/ascend/client/ChangeCulture", {
    currentContentId: currentContentId,
    cultureName: cultureName,
    currentRelativePath: window.location.pathname + window.location.search,
    currentCultureName: currentCultureName,
    replicatedSiteBusinessName: replicatedSiteBusinessName
  });
}
export async function GetMenuCultures( currentContentId: number):  Promise<CultureItem[]> {
  return  await Get("/umbraco/ascend/client/GetMenuCultures?currentContentId="+currentContentId);
}

export async function GetKitCategoryCode(countryCode: string): Promise<string> {
  return await Get("/umbraco/ascend/client/GetKitCategoryCode?countryCode="+countryCode);
}
